import React, { useMemo, useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { createRoomAction } from '#ducks/rooms'

import { roomNameValidation } from '../model/roomNameValidator'
import { InputWithButton } from '#shared/ui/InputWithButton'
import { Typography } from '@memebattle/ui'

export const CreateRoomContainer = () => {
  const dispatch = useDispatch()

  const [name, setName] = useState('')

  const validationErrors: { error: string } | null = useMemo(() => roomNameValidation(name), [name])

  const handleNameChange = useCallback<React.ChangeEventHandler<HTMLInputElement>>(
    e => {
      setName(e.target.value)
    },
    [setName],
  )

  const handleCreateRoom = useCallback(() => {
    if (name.trim() !== '' && !validationErrors) {
      dispatch(createRoomAction({ name }))
    }
  }, [name, validationErrors, dispatch])

  const handleCreateRoomKeyDown = useCallback<React.KeyboardEventHandler<HTMLInputElement>>(
    e => {
      if (e.key === 'Enter') {
        handleCreateRoom()
      }
    },
    [handleCreateRoom],
  )

  return (
    <InputWithButton>
      <InputWithButton.Input
        slotProps={{ input: { 'data-test-id': 'CreateGameInput' } as object }}
        placeholder="Room name..."
        onChange={handleNameChange}
        onKeyDown={handleCreateRoomKeyDown}
      />
      <InputWithButton.ButtonWrapper>
        <InputWithButton.Button data-test-id="CreateGameButton" onClick={handleCreateRoom} disabled={!name || !!validationErrors} variant="contained">
          <Typography fontSize="inherit">Create</Typography>
        </InputWithButton.Button>
      </InputWithButton.ButtonWrapper>
    </InputWithButton>
  )
}
